export const useTime = () => {
    const localTimeString = initTime => {
        return new Date(initTime * 1000).toLocaleString()
    }

    const localDateString = initTime => {
        return new Date(initTime * 1000).toLocaleDateString()
    }

    const convertUtc0ToUtc9 = timeText => {
        return new Date(timeText).toLocaleString()
    }

    const convertInputToTimezone = (inputData, localTime?: number) => {
        if (!inputData || inputData === '0000-00-00T00:00') {
            return undefined
        }
        const offset = localTime === undefined ? 9 : localTime
        const sign = offset >= 0 ? '+' : '-'
        const absOffset = Math.abs(offset)
        const offsetString = `${sign}${String(absOffset).padStart(2, '0')}:00`

        const dateWithOffset = new Date(`${inputData}${offsetString}`)
        if (isNaN(dateWithOffset.getTime())) return undefined

        return dateWithOffset.toISOString()
    }

    const convertTimezoneToInput = (timezone, localTime?: number) => {
        if (!timezone || timezone === '0000-00-00T00:00') {
            return '0000-00-00T00:00'
        }
        const date = new Date(timezone)
        if (isNaN(date.getTime())) {
            return '0000-00-00T00:00'
        }

        const offsetHours = localTime === undefined ? 9 : localTime
        const offsetDate = new Date(date.getTime() + offsetHours * 60 * 60 * 1000)

        const year = offsetDate.getUTCFullYear()
        const month = String(offsetDate.getUTCMonth() + 1).padStart(2, '0')
        const day = String(offsetDate.getUTCDate()).padStart(2, '0')
        const hour = String(offsetDate.getUTCHours()).padStart(2, '0')
        const minute = String(offsetDate.getUTCMinutes()).padStart(2, '0')

        return `${year}-${month}-${day}T${hour}:${minute}`
    }

    const convertInputToTimestamp = date => {
        return new Date(date).getTime() / 1000
    }

    const convertTimestampToInput = (timestamp?: number) => {
        if (!timestamp) {
            return ''
        }
        const date = new Date(timestamp * 1000)
        const convertHour = date.getHours()

        const formatYYYYMMDD = date.toISOString()?.split('T')[0]
        const getHour = () => {
            if (convertHour < 10) {
                return `0${convertHour}`
            } else {
                return convertHour
            }
        }
        const getMinute = () => {
            if (date.getMinutes() < 10) {
                return `0${date.getMinutes()}`
            } else {
                return date.getMinutes()
            }
        }

        return formatYYYYMMDD + 'T' + getHour() + ':' + getMinute()
    }

    function formatUTCDate(timestamp: number, timezoneOffset?: number): string {
        const date = new Date(timestamp)

        // 오프셋을 시간 단위로 밀리초로 변환하여 적용
        const offsetMs = (timezoneOffset || 0) * 60 * 60 * 1000
        const adjustedDate = new Date(date.getTime() + offsetMs)

        const year = adjustedDate.getUTCFullYear()
        const month = String(adjustedDate.getUTCMonth() + 1).padStart(2, '0')
        const day = String(adjustedDate.getUTCDate()).padStart(2, '0')
        const hours = String(adjustedDate.getUTCHours()).padStart(2, '0')
        const minutes = String(adjustedDate.getUTCMinutes()).padStart(2, '0')

        return `${year}-${month}-${day} ${hours}:${minutes}`
    }

    return {
        localTimeString,
        localDateString,
        convertUtc0ToUtc9,
        convertInputToTimezone,
        convertTimezoneToInput,
        convertInputToTimestamp,
        convertTimestampToInput,
        formatUTCDate,
    }
}
